var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({height: _vm.height, zIndex: _vm.zIndex})},[_c('div',{class:_vm.className,style:({top: (_vm.isSticky ? _vm.stickyTop +'px' : ''), zIndex: _vm.zIndex, position: _vm.position, width: _vm.width, height: _vm.height})},[_vm._t("default",function(){return [_c('div',[_vm._v("sticky")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }